<template>
	<div class="business-income my-3">
		<b-form @submit.prevent="update">
			<b-row>
				<b-col cols="8">
					<el-radio-group v-model="business_income_type">
						<el-radio label="Company Bank Statement">Company Bank Statement</el-radio>
						<el-radio label="Borang B">Borang B</el-radio>
					</el-radio-group>
				</b-col>

				<b-col cols="12" v-if="business_income_type === 'Company Bank Statement'">
					<b-col cols="8" class="px-0">
						<b-form-group label="Total Income" class="my-4">
							<b-form-input v-model="total_business_income" type="number" disabled></b-form-input>
						</b-form-group>
					</b-col>
					<b-row>
						<b-col cols="12">
							<b-form-group label="Business Income">
								<b-row>
									<b-col md="4" cols="12" class="d-flex align-items-center my-2" v-for="(business, index) in businesses"
										:key="index">
										<CurrencyInput v-model="business.amount"
											:options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
											:inputPlaceholder="`Month ${index + 1}`" />
									</b-col>
								</b-row>
							</b-form-group>
							<b-button-group class="w-100">
								<b-button @click="addMonths" :disabled="businesses.length >= 12" variant="outline-primary"
									class="mt-3">+ Add</b-button>
								<b-button @click="removeMonths" :disabled="businesses.length <= 0" variant="outline-danger"
									class="mt-3">- Remove</b-button>
							</b-button-group>
						</b-col>

						<b-col md="8" cols="12">
							<b-form-group label="Entity" class="my-4">
								<el-select v-model="form.business_entity" placeholder="Select">
									<el-option label="Sole Proprietor" value="Sole Proprietor"></el-option>
									<el-option label="Partnership" value="Partnership"></el-option>
									<el-option label="Sdn. Bhd" value="Sdn. Bhd"></el-option>
								</el-select>
							</b-form-group>
						</b-col>
					</b-row>
				</b-col>
				<b-col cols="8" v-else>
					<b-form-group label="Total Income" class="my-4">
						<CurrencyInput v-model="form.borang_b_amount"
							:options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }" />
					</b-form-group>
				</b-col>

				<b-col cols="8"
					v-if="business_income_type === 'Company Bank Statement' && form.business_entity === 'Partnership'">
					<b-form-group label="Partners" class="my-4">
						<b-form-input v-model="form.business_partners" type="text" placeholder="Enter Partners"></b-form-input>
					</b-form-group>
				</b-col>

				<b-col cols="12"
					v-if="business_income_type === 'Company Bank Statement' && form.business_entity === 'Sdn. Bhd'">
					<b-row>
						<b-col md="8" cols="12">
							<b-form-group label="IFF Code" class="my-4">
								<el-select v-model="form.business_iff_code_id" placeholder="Select IFF Code">
									<el-option v-for="iffCode in tables.iff_codes" :key="iffCode.iff_code_id" :label="iffCode.code"
										:value="iffCode.iff_code_id">
									</el-option>
								</el-select>
							</b-form-group>
						</b-col>
						<b-col md="8" cols="12">
							<b-form-group label="Underwriter IFF" class="my-4">
								<b-form-input @keydown="preventNonNumericInput" v-model="form.business_underwriter_iff" type="text"
									maxlength="3" placeholder="Enter Underwriter IFF" required></b-form-input>
							</b-form-group>
						</b-col>
						<b-col md="8" cols="12">
							<b-form-group label="Shareholding" class="my-4">
								<b-form-input v-model="form.business_shareholding" @keydown="preventNonNumericInput" type="text"
									placeholder="Enter Shareholding"></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
				</b-col>
			</b-row>
			<!-- <b-col cols="4" class="mt-3 px-0">
                <b-button block variant="primary" type="submit">Save</b-button>
            </b-col> -->
		</b-form>
	</div>
</template>
<script>
import { Radio, RadioGroup, Select, Option } from 'element-ui'
import {
	notifyFunctionMixin,
	helperFunctionMixin,
	axios,
	services,
	getHeader
} from '@/assets/js/httpImports.js'
import { mapActions } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore'
import { EventBus } from '@/main'
import CurrencyInput from '@/components/CurrencyInput'

export default {
	name: 'business-income',
	props: ['customer', 'tables', 'main_form'],
	components: {
		CurrencyInput,
		[Radio.name]: Radio,
		[RadioGroup.name]: RadioGroup,
		[Select.name]: Select,
		[Option.name]: Option,
	},
	mixins: [notifyFunctionMixin, helperFunctionMixin],
	data() {
		return {
			businesses: [],
			business_income_type: this.customer.incomes.main.business_income_type ?? '',
			form: {
				borang_b_amount: this.customer.incomes.main.borang_b_amount ?? '',
				business_entity: this.customer.incomes.main.business_entity ?? '',
				business_partners: this.customer.incomes.main.business_partners ?? '',
				business_iff_code_id: this.customer.incomes.main.business_iff_code_id ?? '',
				business_underwriter_iff: this.customer.incomes.main.business_underwriter_iff ?? 10,
				business_shareholding: this.customer.incomes.main.business_shareholding ?? ''
			},
		}
	},
	computed: {
		isForeigIncome() {
			return false
			// const wc = _gHlp.getValue(this.main_form, 'working_country');
			// return !_gHlp.isEmpty(wc) && wc != 'Malaysia';
		},
		currencyRate() {
			return _gHlp.getValue(this.main_form, 'foreign_currency');
		},
		total_business_income() {
			let count = 0;
			let total = this.businesses.reduce((acc, business) => {
				const amount = parseFloat(business.amount);
				if (isNaN(amount)) {
					return acc;
				}
				count++
				return acc + amount;
			}, 0);

			total = (total / count * 0.1)

			if (this.form.business_entity === 'Partnership' && this.form.business_partners > 0) {
				total = total / this.form.business_partners
			}

			if (this.form.business_entity === 'Sdn. Bhd' && this.form.business_shareholding) {
				total = total * (this.form.business_shareholding / 100)
			}

			return parseFloat(total.toFixed(2));
		},
	},
	created() {
		EventBus.$on('collect-income-data', this.sendIncomeData);
	},
	watch: {
		customer: {
			handler: function (newValue) {
				if(!_gHlp.isEmpty(newValue)){
					this.initData();
				}
			},
			immediate: true
		},
		main_form: {
			handler: function (newValue) {
				if(!_gHlp.isEmpty(newValue)){
					this.initData();
				}
			},
			immediate: true
		},
	},
	methods: {
		...mapActions(useCustomerStore, ['getCustomer']),
		initData(){
			this.businesses = _gHlp.getValue(this.customer,'incomes.business',[]);
			this.business_income_type = this.customer.incomes.main.business_income_type ?? '',
			this.form = {
				borang_b_amount: _gHlp.getValue(this.customer,'incomes.main.borang_b_amount',0),
				business_entity: _gHlp.getValue(this.customer,'incomes.main.business_entity',''),
				business_partners: _gHlp.getValue(this.customer,'incomes.main.business_partners',''),
				business_iff_code_id: _gHlp.getValue(this.customer,'incomes.main.business_iff_code_id',''),
				business_underwriter_iff: _gHlp.getValue(this.customer,'incomes.main.business_underwriter_iff',10),
				business_shareholding: _gHlp.getValue(this.customer,'incomes.main.business_shareholding','')
			}

			if(this.isForeigIncome){
				this.businesses.forEach(el => {
					el.amount = _gHlp.currencyFromRM(el.amount, this.currencyRate)
				});
				this.form.borang_b_amount = _gHlp.currencyFromRM(this.form.borang_b_amount, this.currencyRate);
			}
		},
		setData() {
			let businesses = this.businesses.map(obj => {
				return {
					...(obj.customer_business_income_id && { customer_business_income_id: obj.customer_business_income_id }),
					amount: (this.isForeigIncome) ? _gHlp.currencyToRM(obj.amount, this.currencyRate) : obj.amount
				}
			})

			let data = {
				businesses: businesses,
				borang_b_amount: (this.isForeigIncome) ? _gHlp.currencyToRM(this.form.borang_b_amount, this.currencyRate) : this.form.borang_b_amount,
				// business_income: this.form.business_income,
				business_entity: this.form.business_entity,
				business_partners: this.form.business_partners,
				business_iff_code_id: this.form.business_iff_code_id,
				business_underwriter_iff: this.form.business_underwriter_iff,
				business_shareholding: this.form.business_shareholding,
				business_income_type: this.business_income_type
			}

			return data;
		},
		update() {
			let data = this.setData()

			axios.post(services.customer + 'customer/' + this.$route.params.customer_id + '/income/businesses', data, { headers: getHeader() })
				.then(res => {
					this.notifySuccess('<b>Business Income: ' + this.customer.name + '</b> - Successfully Updated.')
					this.getCustomer(this.$route.params.customer_id)
				})
				.catch(e => {
					this.errorFunction(e)
				})
		},
		addMonths() {
			if (this.businesses.length < 12) {
				this.businesses.push({ amount: '' });
			}
		},
		removeMonths() {
			if (this.businesses.length > 0) {
				this.businesses.pop();
			}
		},
		sendIncomeData() {
			this.$emit('income-data-collected', this.setData());
		},
		preventNonNumericInput(event) {
			const keyCode = event.keyCode || event.which;
			const keyValue = String.fromCharCode(keyCode);
			const currencyRegex = /^[\d.,$]+(\.[\d.,$]+)?$/;
			const allowedKeys = [8, 37, 38, 39, 40, 46];
			if (keyCode !== 190 && !currencyRegex.test(keyValue) && !allowedKeys.includes(keyCode)) {
				event.preventDefault();
			}
		},
	}
}
</script>